import { render, staticRenderFns } from "./change-modal.vue?vue&type=template&id=2bfca2a9&"
import script from "./change-modal.vue?vue&type=script&lang=js&"
export * from "./change-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports